import { BEACH_ACTIVITIES, BEACH_NEARBY_TAGS } from "@/data/beaches";

/** "What do you want to do?" options. */
export const ACTIVITY_OPTIONS = BEACH_ACTIVITIES;

/** "What's nearby?" options. */
export const NEARBY_OPTIONS = BEACH_NEARBY_TAGS;

/** Water conditions, calmest first — how the beach actually feels to swim in. */
export const WATER_LEVELS = [
  { value: "Very calm", label: "Very calm — like a pool" },
  { value: "Calm", label: "Calm & protected" },
  { value: "Moderate chop", label: "Some chop" },
  { value: "Rough", label: "Rough — wading & watching" },
];

export const ANY = "any";

export const EMPTY_BEACH_FILTERS = { query: "", activity: ANY, nearby: ANY, water: ANY };

const norm = (v) =>
  String(v ?? "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const haystack = (beach) =>
  norm(
    [
      beach.name,
      beach.area,
      beach.region,
      beach.vibe,
      beach.bestFor,
      beach.description,
      beach.water,
      ...(beach.activities || []),
      ...(beach.nearbyTags || []),
      ...(beach.nearby || []).map((n) => n.name),
    ]
      .filter(Boolean)
      .join(" ")
  );

/** Every chosen dropdown narrows the list; the search box matches any field. */
export const beachMatches = (beach, filters) => {
  if (filters.activity !== ANY && !(beach.activities || []).includes(filters.activity)) return false;
  if (filters.nearby !== ANY && !(beach.nearbyTags || []).includes(filters.nearby)) return false;
  if (filters.water !== ANY && beach.waterLevel !== filters.water) return false;

  const tokens = norm(filters.query).split(/\s+/).filter(Boolean);
  if (!tokens.length) return true;
  const hay = haystack(beach);
  return tokens.every((t) => hay.includes(t));
};

export const filterBeaches = (beaches, filters) => beaches.filter((beach) => beachMatches(beach, filters));

export const hasBeachFilters = (filters) =>
  filters.query.trim() !== "" || filters.activity !== ANY || filters.nearby !== ANY || filters.water !== ANY;